import { library } from "@fortawesome/fontawesome-svg-core";

import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";

library.add(faCaretDown);
library.add(faArrowRight);
